import { getAnalyticsAbExperiments } from '#/utils/analytics/abExperiments/analyticsAbExperiments';
import { getAnalyticsAbExperimentsConcatenatedString } from '#/utils/analytics/abExperiments/getAnalyticsAbExperimentsConcatenatedString';
import { getCookieValue } from '#/utils/cookies';
import { getItem, setItem } from '#/utils/localStorage';

import { getAnalyticsApplicationContextProps } from './getAnalyticsApplicationContextProps';

export function windowDataLayerPush(baseEventData: Record<string, unknown>) {
  const eventData = {
    ...baseEventData,
    ...getAnalyticsApplicationContextProps(),
    experiments: getAnalyticsAbExperimentsConcatenatedString(
      getAnalyticsAbExperiments(),
    ),
  };

  if (getCookieValue('_traceAnalytics')) {
    const trace = (getItem('_analyticsTrace') ?? []) as Record<
      string,
      unknown
    >[];
    trace.push(eventData);
    setItem('_analyticsTrace', trace);
  }

  window.dataLayer.push(eventData);
}
